import { createSlice } from "@reduxjs/toolkit";

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    basicAnalytics: null,
    practiceSolution: null,
    topicWiseComparison: null,
    subjectWiseAnalysis: [],
    overallAnalytics: null,
    questionAnalytics: null,
    clearBasicAnalytics:null,

    // ✅ NEW (AITS attempt tracking)
    selectedAttemptId: 0,

    loading: {
      basic: false,
      practice: false,
      topic: false,
      subject: false,
      overall: false,
      question: false,
    },

    error: {
      basic: null,
      practice: null,
      topic: null,
      subject: null,
      overall: null,
      question: null,
    },
  },

  reducers: {
    // ================= BASIC ANALYTICS =================
    fetchBasicAnalyticsRequest: (state) => {
      state.loading.basic = true;
      state.error.basic = null;
    },

    clearBasicAnalytics: (state) => {
      state.basicAnalytics = null;
      state.error.basic = null;
    },
    setSelectedAttemptId: (state, action) => {
      state.selectedAttemptId = Number(action.payload);
    },
    fetchBasicAnalyticsSuccess: (state, action) => {
      state.loading.basic = false;
      state.basicAnalytics = action.payload;

      // ✅ AITS: STORE attempt_count SOURCE OF TRUTH
      if (action.payload?.data?.selected_attempt !== undefined) {
        state.selectedAttemptId = Number(action.payload.data.selected_attempt);
      }
    },

    fetchBasicAnalyticsFailure: (state, action) => {
      state.loading.basic = false;
      state.error.basic = action.payload;
    },

    // ================= PRACTICE SOLUTION =================
    fetchPracticeSolutionRequest: (state) => {
      state.loading.practice = true;
      state.error.practice = null;
    },
    fetchPracticeSolutionSuccess: (state, action) => {
      state.loading.practice = false;
      state.practiceSolution = action.payload;
    },
    fetchPracticeSolutionFailure: (state, action) => {
      state.loading.practice = false;
      state.error.practice = action.payload;
    },

    // ================= TOPIC-WISE =================
    fetchTopicWiseComparisonRequest: (state) => {
      state.loading.topic = true;
      state.error.topic = null;
    },
    fetchTopicWiseComparisonSuccess: (state, action) => {
      state.loading.topic = false;
      state.topicWiseComparison = action.payload;
    },
    fetchTopicWiseComparisonFailure: (state, action) => {
      state.loading.topic = false;
      state.error.topic = action.payload;
    },

    // ================= SUBJECT-WISE =================
    fetchSubjectWiseAnalysisRequest: (state) => {
      state.loading.subject = true;
      state.error.subject = null;
    },
    fetchSubjectWiseAnalysisSuccess: (state, action) => {
      state.loading.subject = false;
      state.subjectWiseAnalysis = action.payload;
    },
    fetchSubjectWiseAnalysisFailure: (state, action) => {
      state.loading.subject = false;
      state.error.subject = action.payload;
    },

    // ================= OVERALL =================
    fetchOverallAnalyticsRequest: (state) => {
      state.loading.overall = true;
      state.error.overall = null;
    },
    fetchOverallAnalyticsSuccess: (state, action) => {
      state.loading.overall = false;
      state.overallAnalytics = action.payload;
    },
    fetchOverallAnalyticsFailure: (state, action) => {
      state.loading.overall = false;
      state.error.overall = action.payload;
    },

    // ================= QUESTION =================
    fetchQuestionAnalyticsRequest: (state) => {
      state.loading.question = true;
      state.error.question = null;
    },
    fetchQuestionAnalyticsSuccess: (state, action) => {
      state.loading.question = false;
      state.questionAnalytics = action.payload;
    },
    fetchQuestionAnalyticsFailure: (state, action) => {
      state.loading.question = false;
      state.error.question = action.payload;
    },
  },
});

export const {
  fetchBasicAnalyticsRequest,
  clearBasicAnalytics,
  setSelectedAttemptId,
  fetchBasicAnalyticsSuccess,
  fetchBasicAnalyticsFailure,
  fetchPracticeSolutionRequest,
  fetchPracticeSolutionSuccess,
  fetchPracticeSolutionFailure,
  fetchTopicWiseComparisonRequest,
  fetchTopicWiseComparisonSuccess,
  fetchTopicWiseComparisonFailure,
  fetchSubjectWiseAnalysisRequest,
  fetchSubjectWiseAnalysisSuccess,
  fetchSubjectWiseAnalysisFailure,
  fetchOverallAnalyticsRequest,
  fetchOverallAnalyticsSuccess,
  fetchOverallAnalyticsFailure,
  fetchQuestionAnalyticsRequest,
  fetchQuestionAnalyticsSuccess,
  fetchQuestionAnalyticsFailure,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
